import '../Admin/admin-shared.css'
import '../tools-pages.css'

import { useEffect, useState } from 'react'

import { PageHeader, Spinner, Writer } from '../../Components'
import { useAuth } from '../../Provider/AuthProvider'
import { FC, useCQuery } from '../../Services'
import { cap } from '../../State'
import { translations } from '../../translations'
import { showToast } from '../../utils/toast'
import { GigiChatMessages } from '../Gigi/GigiForm/GigiChatMessages'
import SettingsParameterTest from './Components/SettingsParameterTest'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

export function NewChat() {
  const { data: unitsData = [] } = useCQuery(['units'])
  const { data: travellersData = [], isSuccess: isSuccessTravellers } = useCQuery(['travellers'])
  const { data: environments = [], isSuccess: isSuccessEnvironments } = useCQuery(['environments'])
  const [conversationId, setConversationId] = useState()
  const { data: conversation = {} } = useCQuery(['conversation', conversationId])
  const units = unitsData?.map(({ name }) => name)
  const [travellersOptions, setTravellersOptions] = useState([])
  const [selectedUnit, setSelectedUnit] = useState('newMessage')
  const [selectedPID, setSelectedPID] = useState()
  const [selectedFormalita, setSelectedFormalita] = useState(75)
  const { user = {} } = useAuth()
  const { user: userObj = {} } = user || {}
  const { id: userId, username } = userObj
  const [messages, setMessages] = useState([])
  const [selectedEmail, setSelectedEmail] = useState(
    username === 'mbolla@siapcn.it' ? 'mbolla@siapcn.it' : 'mranocchia@siapcn.it'
  )
  const [selectedEnvironment, setSelectedEnvironment] = useState()

  useEffect(() => {
    isSuccessEnvironments &&
      !selectedEnvironment &&
      setSelectedEnvironment(
        environments.find(({ tomcatCode }) => user?.user?.environment?.tomcatCode === tomcatCode)
          ?.codSociety || ''
      )
  }, [environments])

  useEffect(() => {
    if (conversation?.messages?.length !== messages?.length) {
      setMessages(
        conversation?.messages
          ?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
          ?.map(({ message, sender, createdAt }) => ({
            user: sender === 'traveller' ? conversation?.traveller?.email : 'Nora',
            message,
            createdAt: new Date(createdAt)
          })) || []
      )
    }
  }, [conversation?.messages])

  useEffect(() => {
    if (isSuccessTravellers) {
      const environmentId = environments?.find(
        ({ codSociety }) => codSociety === selectedEnvironment
      )?.id
      setTravellersOptions(
        travellersData
          ?.filter(({ environmentId: envId }) => envId === environmentId)
          ?.map(({ pid }) => pid)
      )
      setSelectedPID(
        travellersData?.filter(({ environmentId: envId }) => envId === environmentId)?.[0]?.pid
      )
    }
  }, [travellersData, selectedEnvironment])

  const sendMessage = async (message, attachments) => {
    setMessages([...messages, { user: 'me', message }])
    try {
      const res = await FC.service('public').create({
        type: 'testUnit',
        unit: 'newMessage',
        attachments,
        user: userId,
        pid: selectedPID,
        tomcatCode: user?.user?.environment?.tomcatCode,
        userEmail: selectedEmail,
        operatorEmail: selectedEmail,
        userInput: message,
        levelFormalita: selectedFormalita || 75,
        isDebug: false,
        codSociety: selectedEnvironment
      })
      res?.conversationData?.conversationId !== conversationId &&
        setConversationId(res?.conversationData?.conversationId)
      return true
    } catch (error) {
      showToast('error', t.errore, error?.message || "Errore durante l'invio del messaggio")
      return false
    }
  }
  if (!isSuccessTravellers)
    return (
      <div className="chat-page">
        <Spinner />
      </div>
    )
  return (
    <div className="chat-page admin-page--wide">
      <PageHeader title={t.testChat} subtitle={t.testChatSubtitle} />

      <div className="nsec community-section">
        <div className="nsec__head">
          <div className="nsec__ico">
            <i className="pi pi-cog" style={{ fontSize: 16 }} />
          </div>
          <h3 className="nsec__title">{t.testParameters}</h3>
          <div style={{ marginLeft: 'auto' }}>
            <span className="nbadge nbadge--info">
              <i className="pi pi-wrench" style={{ fontSize: 11, marginRight: 4 }} />
              {t.mcDebug}
            </span>
          </div>
        </div>
        <div className="nsec__body">
          <SettingsParameterTest
            selectedFormalita={selectedFormalita}
            setSelectedFormalita={setSelectedFormalita}
            units={units}
            debugMode
            selectedUnit={selectedUnit}
            setSelectedUnit={setSelectedUnit}
            travellersOptions={travellersOptions}
            selectedPID={selectedPID}
            setSelectedPID={setSelectedPID}
            selectedEmail={selectedEmail}
            setSelectedEmail={setSelectedEmail}
            selectedEnvironment={selectedEnvironment}
            setSelectedEnvironment={setSelectedEnvironment}
            environmentList={environments?.filter(
              ({ tomcatCode }) => user?.user?.environment?.tomcatCode === tomcatCode
            )}
          />
        </div>
      </div>

      <div className="ncard" style={{ marginTop: 16 }}>
        <div className="ncard__head">
          <div className="ncard__ico">
            <i className="pi pi-comments" style={{ fontSize: 16 }} />
          </div>
          <div>
            <h3 className="ncard__title">{t.conversation}</h3>
            <div className="ncard__sub">
              {t.testConversation} · {messages.length} {t.messages}
            </div>
          </div>
        </div>
        <div className="ncard__body chat-card-body">
          <div className="chat-messages-area">
            <GigiChatMessages messages={messages} isReadOnly={false} />
          </div>
          <div className="chat-writer-row">
            <Writer sendMessage={sendMessage} composerVariant="gigi" />
          </div>
        </div>
      </div>
    </div>
  )
}
